module.exports = __webpack_public_path__ + "static/media/rocket.f9020597.svg";